import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { DisplayItem } from 'design-system';

/**
 * Helper function to generate a DisplayItem array
 * from GeneralCatalogItem array
 */
export function mapCatatalogToDisplay(
  catalogArray: GeneralCatalogItem[],
): DisplayItem[] {
  return catalogArray.map(
    (catalogItem): DisplayItem => ({
      Text: catalogItem.name,
      Value: catalogItem.code,
    }),
  );
}

export function findIdByCode(
  catalogArray: GeneralCatalogItem[],
  code: string,
): number {
  const item = catalogArray.find((catalogItem) => catalogItem.code === code);
  return item?.id || 0;
}

export function findNameByCode(
  catalogArray: GeneralCatalogItem[],
  code: string,
): string {
  const item = catalogArray.find((catalogItem) => catalogItem.code === code);
  return item?.name || '';
}

export function findCodeByCode(
  catalogArray: GeneralCatalogItem[],
  code: string,
): string {
  const item = catalogArray.find((catalogItem) => catalogItem.code === code);
  return item?.code ?? '';
}
